import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter } from 'react-router-dom';


const theme = createTheme({
  palette: {
    primary: {
      main: '#2c3341',
    },
    secondary: {
      main: '#fff',
    },
  },
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   
    <ThemeProvider theme={theme}>
    <BrowserRouter>
    <CssBaseline />
   
    <App />
    
    </BrowserRouter>
    </ThemeProvider>
   
  </React.StrictMode>
);

reportWebVitals();
